import { Component } from '@angular/core';
import { EventsService } from './services/events.service';
import { AuthService } from './services/auth.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  navExpanded = false;

  toggleExpandNav() {
    this.navExpanded = !this.navExpanded;
  }

  constructor(private eventService: EventsService, private authService: AuthService) {
  }
}
